export default "/list/static/images/millions-of-travlers.svg";